import { PROTOTYPE_MOBILE_PREFIX } from "../../mobileRoutePrefix";

/** Sliding Puzzle Quest — isolated routes (no UserLayout / site chrome). */
export const SLIDING_PUZZLE_QUEST_TITLE = "Sliding Puzzle Quest";
/** @deprecated Use {@link SLIDING_PUZZLE_QUEST_TITLE} */
export const SLIDING_PUZZLE_MASTER_TITLE = SLIDING_PUZZLE_QUEST_TITLE;

const SLIDING_BASE = `${PROTOTYPE_MOBILE_PREFIX}/sliding`;

export const MAIN_PATH = SLIDING_BASE;
export const PLAY_PATH = `${SLIDING_BASE}/play`;
export const LIBRARY_PATH = `${SLIDING_BASE}/library`;
export const MY_PUZZLES_PATH = `${SLIDING_BASE}/my-puzzles`;
export const SETTINGS_PATH = `${SLIDING_BASE}/settings`;
export const ACCOUNT_DELETION_CONFIRMED_PATH = `${SLIDING_BASE}/account-deletion-confirmed`;

/** App Store screenshot draft pages (same pattern as mobile-jigsaw). */
export const SCREENSHOTS_MAIN_PATH = `${SLIDING_BASE}/screenshots`;
export const SCREENSHOT_SCENE_PATH = `${SLIDING_BASE}/screenshot/:slug`;

export function screenshotPath(slug) {
    return `${SLIDING_BASE}/screenshot/${slug}`;
}

const SCREENSHOT_PRODUCTION_ORIGIN =
    (typeof process !== "undefined" && process.env.REACT_APP_PUBLIC_URL?.trim()) ||
    "https://www.puzzleinteract.com";

/** Public App Store screenshot scene URL (production). */
export function screenshotProductionUrl(slug) {
    return `${SCREENSHOT_PRODUCTION_ORIGIN}${screenshotPath(slug)}`;
}

/** Demo board image under `public/`. */
export const DEMO_IMAGE = `${process.env.PUBLIC_URL || ""}/v4/sliding-logo-board.png`;

export const QUICK_PLAY_GRID = 4;
export const CHALLENGE_GRID = 6;

export const DIFFICULTIES = ["easy", "medium", "hard"];

export const DIFFICULTY_LABELS = {
    easy: "Easy",
    medium: "Medium",
    hard: "Hard",
};
